export default {
    require: function() {
        return {validate: (val) => !!val, message: '必须填写'}
    },
    eqLength: function(length) {
        return {validate: (val) => val.length == length, message: '长度必须等于' + length + '位'}
    },
    minLength: function(length) {
        return {validate: (val) => val.length >= length, message: '长度不可小于' + length + '位'}
    },
    maxLength: function(length) {
        return {validate: (val) => val.length <= length, message: '长度不可大于' + length + '位'}
    },
    validateAccount: function(){
        return {
            validate:(value) => /^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4e00-\u9fa5]+$/.test(value), 
            message: "账号不符合规范"
         }
     },
    phoneNumber: function(){
         return {
             validate: value=> (((/^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/)) | (/^((0\d{2,3}-\d{7,8})|(1[3567894]\d{9}))$/) .test(value)),
             message: "手机号不符合规范"
         }
    },
    tel: function(){
        return {
            validate: value=> (/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/).test(value),
            message: "电话号不符合规范"
        }
   },
    minValue: function(minVal) {
        return {validate: (val) => minVal? val >= minVal : true, message: '不可小于' + minVal}
    },
    maxValue: function(maxVal) {
        return {validate: (val) => val <= maxVal, message: '不可大于' + maxVal}
    },

    email: function(){
        return {
          // validate: val => /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val),
          //   validate: val => /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g.test(val),
          //   message: "输入有效的邮箱"
          // ,
          validate: val => /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(val),
          message: "输入有效的邮箱"
        }

    },

    idcard: function(){
        return{
          validate: (val) => /^\d{18}|[0-9x]{18}|[0-9X]{18}?$/.test(val),
          message: "身份证号码不正确"
        }
    },

    digital: function() {
        return{
            validate: (val) => /^\d+.?\d{0,99}$/.test(val),
            message: "只允许输入数字"
          }
    },

    confirmPassword: function(refer){
        return{
            validate: (val) => val==refer,
            message: "密码输入不一致"
          }
    }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js